import { schema } from 'normalizr';

import { page } from './page';

export const form = new schema.Entity('form', {
  pages: [page],
});
